import { Twitter, Instagram, Mail } from "lucide-react";
import { Reveal, smoothScrollTo } from "./shared";

const SOCIALS = [
  { icon: Twitter, label: "twitter", url: "https://x.com/xxxvideocasting" },
  {
    icon: Instagram,
    label: "instagram",
    url: "https://www.instagram.com/furturestarstoday/",
  },
];

const Footer = () => (
  <footer
    id="footer"
    data-testid="site-footer"
    className="relative bg-[#0a0a0a] border-t border-[#222] py-20 lg:py-28"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal>
        <h2 className="font-display text-white font-extrabold tracking-tighter uppercase text-3xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl mb-14">
          Casting Tomorrow&rsquo;s
          <br />
          <span className="text-[#d4af37]">Adult Stars</span> Today
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-[#222] pt-12">
        <div>
          <p className="text-[#666] text-xs tracking-[0.3em] uppercase mb-3">
            Contact
          </p>
          <a
            data-testid="footer-email"
            href="mailto:casting@xxxvideocasting.com"
            className="group inline-flex items-center gap-2 text-white text-lg hover:text-[#d4af37] transition-colors duration-300"
          >
            <Mail className="h-4 w-4" />
            casting@xxxvideocasting.com
          </a>
        </div>

        <div>
          <p className="text-[#666] text-xs tracking-[0.3em] uppercase mb-3">
            Follow
          </p>
          <div className="flex items-center gap-4">
            {SOCIALS.map(({ icon: Icon, label, url }) => (
              <a
                key={label}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-${label}`}
                aria-label={label}
                className="flex h-10 w-10 items-center justify-center border border-[#2a2a2a] text-[#cccccc] hover:border-[#d4af37] hover:text-[#d4af37] transition-colors duration-300"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="md:text-right">
          <p className="text-[#666] text-xs tracking-[0.3em] uppercase mb-3">
            Apply
          </p>
          <button
            data-testid="footer-apply-btn"
            onClick={() => smoothScrollTo("apply")}
            className="font-display text-sm font-bold tracking-[0.2em] uppercase text-white hover:text-[#d4af37] transition-colors duration-300"
          >
            Start Application &rarr;
          </button>
        </div>
      </div>

      <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-[#222] pt-8">
        <div className="flex items-center gap-3">
          <span className="flex h-7 w-7 items-center justify-center rounded-full border border-[#d4af37]">
            <span className="h-1.5 w-1.5 rounded-full bg-[#d4af37]" />
          </span>
          <span className="font-display text-white text-sm font-bold tracking-[0.2em] uppercase">
            XXX Video Casting
          </span>
        </div>
        <p className="text-[#666] text-xs tracking-wider">
          &copy; 2026 XXX Video Casting. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
